import React from "react";

const Header = () => {
  return (
    <h1 className="header">
      <a href="#" onClick={() => window.location.reload()}>
        BreathHold3000
      </a>
    </h1>
  );
};

export default Header;
